import { useStateWithDependency } from "neetocommons/react-utils";
import { Toastr } from "neetoui";
import { path, remove } from "ramda";

const useDndTable = ({ rowData, onUpdate }) => {
  const [rowDataState, setRowDataState] = useStateWithDependency(rowData, [
    rowData,
  ]);

  const onDrop = async (active, over) => {
    const stateBefore = rowDataState;
    setRowDataState(remove(active.index, 1));

    try {
      await onUpdate(active, over);
    } catch (error) {
      setRowDataState(stateBefore);
      const errors = path(["response", "data", "errors"], error);
      const message = errors && Object.values(errors)[0]?.[0];
      if (message) Toastr.error(message);
    }
  };

  return { rowData: rowDataState, onDrop };
};

export default useDndTable;
